import styled from 'styled-components'
import { SubmitButtonWrapper } from 'components/SubmitButton/styles'

export const AddMailTitle = styled.div`
  line-height: 25px;
  font-size: 18px;

  @media(min-width: 550px) {
    margin-top: 75px;
  }
`

export const AddMailFormWrapper = styled.div`
  width: 100%;
  margin-top: 41px;
  overflow: auto;
  overflow-x: hidden;
  -ms-overflow-style: none;  /* IE and Edge */
  scrollbar-width: none;  /* Firefox */
  ::-webkit-scrollbar {
  display: none;
  }

  & .ant-input-wrapper, & .ant-select-wrapper {
    margin-bottom: 13px;
  }

  & ${SubmitButtonWrapper} {
    padding-top: 10px;
  }
`
